/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, enumeration, identity } from '@gh/core-data';
import {
  OfficeActiveRecordDto,
  OfficeFilterDto,
  OfficeListItemDto,
} from '../models/office-list-item.dto';
import { OfficeStatus } from '../models/office-status.enum';

export const OfficeListItemMapper = entity<OfficeListItemDto>({
  statusValue: enumeration(OfficeStatus),
  renewalDate: date(DateFormat.Date),
  unpaidInvoices: arrayOf(identity()),
});

export const OfficeFilterMapper = entity<OfficeFilterDto>({
  statuses: arrayOf(enumeration(OfficeStatus)),
  types: arrayOf(identity()),
});

export const OfficeActiveRecordMapper = entity<OfficeActiveRecordDto>({
  statusValue: enumeration(OfficeStatus),
  
})